<template>
  <div>

    <v-card>

      <v-toolbar flat dense>
        <v-toolbar-title class="text-subtitle-2">Variações do Produto</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn depressed rounded color="primary" @click="adicionarVariacao" :loading="salvando">
          <v-icon left>mdi-check-circle</v-icon>
          Selecionar Variações
        </v-btn>
      </v-toolbar>

      <!-- <v-card-title class="text-subtitle-2">
        Variações do Produto

        <v-spacer></v-spacer>
        <v-btn color="primary" @click="adicionarVariacao" :loading="salvando">
        <v-icon>mdi-check-circle</v-icon>
        Adicionar
      </v-btn>
      </v-card-title> -->

      <v-divider></v-divider>

      <v-card-text style="height: 300px">
        <v-data-table
          :headers="headers"
          :items="variacoes"
          disabled-sort
          disabled-pagination
          hide-default-footer
        >
          <template v-slot:item="{ item: variacao }">
            <tr>
              <td>{{ variacao.descricao }}</td>
              <td>
                <v-chip 
                  v-for="(valor, index) in variacao.valores"
                  class="mr-2"
                  x-small 
                  color="grey lighten-2"
                  :key="index"
                >{{valor.descricao}}</v-chip>
              </td>
              <td class="text-center">
                <v-btn title="Excluir" icon @click="remover(variacao)">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </v-data-table>

      </v-card-text>

      <v-divider></v-divider>
      
      <v-card-actions class="ml-4" v-if="false">
        <!-- <v-row dense class="mt-3"> -->
          <!-- <v-col cols="12" sm="6"> -->
            <v-select
              v-model="variacao_id"
              label="Variações/Grade"
              style="max-width: 350px"
              filled
              dense
              hide-details
              :items="$store.getters['listas/variacoes']"
            >
              <template v-slot:append-outer>
                <v-btn color="primary" @click="adicionarVariacao" :loading="salvando">
                  <v-icon>mdi-check-circle</v-icon>
                  Adicionar
                </v-btn>
              </template>
            </v-select>
          <!-- </v-col> -->
        <!-- </v-row> -->
      </v-card-actions>
    </v-card>

    <z-dialogo-sim-nao
      ref="dialogoRemover"
      titulo="Remover variação do produto?"
      botaoSim="Remover"
      botaoNao="Cancelar"
      :dividers="true"
      largura="500px"
    >
      Esta variação será removida deste produto.
    </z-dialogo-sim-nao>

    <buscar-variacao ref="buscarVariacao" @selecionar:variacao="selecionarVariacao"></buscar-variacao>

  </div>
</template>

<script>
  import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

  import BuscarVariacao from './BuscarVariacao.vue';
  export default {
    name: 'VariacoesProduto',

    components: {
      BuscarVariacao
    },

    data() {
      return {
        headers: [
          { text: "Variação", value: "descricao", width: "250px", },
          { text: "Valores", value: "varicao.valores", sortable: false },
          {
            text: "Opções",
            value: "",
            width: "80px",
            align: "center",
            sortable: false,
          },
        ],
        variacao_id: null,
        salvando: false,
      }
    },

    async mounted() {
      await this.$store.dispatch('listas/variacoes');

      if (this.$store.getters['listas/variacoes'].length > 0) {
        this.variacao_id = this.$store.getters['listas/variacoes'][0].value;
      }
    },

    computed: {
      produto() {
        return this.$store.state.produtos.produto;
      },

      variacoes() {
        return this.$store.state.produtos.variacoes;
      }
    },

    methods: {
      ...mapActions("produtos", ["removerVariacao"]),

      async adicionarVariacao() {
        this.$refs.buscarVariacao.abrir();
      },

      async selecionarVariacao(variacao) {
        const index = this.variacoes.findIndex(_variacao => _variacao.id == variacao.id);
        if (index == -1) {

          try {
            this.salvando = true;
            await this.$store.dispatch('produtos/adicionarVariacao', variacao.id);
            await this.$store.dispatch('produtos/variacoes', this.produto.id);
          } catch (error) {
            this.$eventbus.notificarErro('Não foi possível adicionar variação', error);
          } finally {
            this.salvando = false;
          }
        }
      },

      async remover(variacao) {
        const response = await this.$refs.dialogoRemover.abrir();

        if (response == true) {
          try {
            await this.removerVariacao({
              produto_id: this.produto.id,
              variacao_id: variacao.id
            });
            this.$refs.dialogoRemover.fechar();
          } catch (error) {
            this.$eventbus.erro('Não foi possível remover variação', error);
          }

        }
      }
    },
  }
</script>

<style scoped>

</style>